import { getJSON } from 'common/util/request'

export const getApiVersion = () => {
    return getJSON(`check/version`, { shouldNormalize: false })
}
